import Vue from "vue"
Vue.config.productionTip = false

import "@/plugins/vueLogger.js"
import "@/plugins/bootstrapVue.js"

import {store} from "@/plugins/store.js"
import router from "@/plugins/router.js"

// bingo
import * as VueGoogleMaps from "gmap-vue";
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_KEY,
    libraries: ["places", "geometry"]
  },
  autobindAllEvents: true,
  installComponents: true
})

import VueI18n from "vue-i18n"
Vue.use(VueI18n)

import Vue2TouchEvents from 'vue2-touch-events'
Vue.use(Vue2TouchEvents, {
    disableClick: false,
    touchClass: '',
    tapTolerance: 10,
    touchHoldTolerance: 400,
    swipeTolerance: 30,
    longTapTimeInterval: 400,
    namespace: 'touch'
})
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.$cookies.config('7d')

// Vue.use(require("vue-shortkey"), { prevent: ["input", "textarea"] })

// bingo
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

import axios from 'axios'
Vue.prototype.$http = axios

router.afterEach((to) => {
    document.title = to.meta.title || "tinkable 데이터 서비스"
})

import App from '@/App.vue'
import i18n from './locales/i18n.js'
new Vue({
  store,
  router,

  created() {
    // this.$log.debug("main.js");
  },

  mounted() {
    // this.$log.debug("main.js");
  },

  updated() {
    // this.$log.debug("main.js");
  },

  i18n,
  render: h => h(App)
}).$mount('#app')
